import React, { PureComponent } from "react";
import moment from "moment-timezone";
import cn from 'classnames';
import "react-circular-progressbar/dist/styles.css";

class Countdown extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      timer: {
        rings1: {
          DAYS: {
            max: 365,
            ms: 86400000
          },
          hours: {
            max: 24,
            ms: 3600000
          },
          mins: {
            max: 60,
            ms: 60000
          }
        },
        rings2: {
          hours: {
            max: 24,
            ms: 3600000
          },
          mins: {
            max: 60,
            ms: 60000
          },
          secs: {
            max: 60,
            ms: 1000
          }
        }
      },
      countdownArray: [],
      lessThanDay: false
    };
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  componentDidMount() {
    this.initTimer();
  }

  initTimer() {
    const timer = { ...this.state.timer };

    this.setState(
      {
        timer
      },
      () => {
        this.startTimer();
      }
    );
  }

  startTimer = () => {
    const timer = { ...this.state.timer };
    let index = 0;
    const { rounds, currentRound, roundInUrl } = this.props;
    let round_number = currentRound;

    let is_previous_round = false;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      round_number = roundInUrl;
      is_previous_round = true;
    }

    const round = rounds.find(i => i.number === round_number);
    let end_date_str = "";
    let is_finished = false;
    if (round) {
      end_date_str = round.end_date;
      is_finished = round.is_finished;
    }

    let end_date = moment.utc(moment(end_date_str));
    let time = end_date - moment.utc(moment());

    if (is_finished === true || is_previous_round === true) {
      time = 0;
    }

    time = time > 0 ? time : 0;

    let rings = timer.rings1;
    let lessThanDay = false;
    if (time <= 86400000) {
      rings = timer.rings2;
      lessThanDay = true;
    }

    const countdownArray = [];
    for (var key in rings) {
      const ring = rings[key];
      let number = time / ring.ms;
      if (number < 0) {
        number = 0;
      }
      number = Math.floor(number);
      countdownArray.push({ key, number, maxNumber: ring.max });
      time = this.drawTimer(index, key, ring, time);
      index++;
    }
    this.setState({
      countdownArray,
      lessThanDay
    });

    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(this.startTimer, 100);
  };

  drawTimer(index, text, data, time) {
    let number = time / data.ms;
    if (number < 0) {
      number = 0;
    }

    let numberText = Math.floor(number);
    return time - numberText * data.ms;
  }

  getSign = (index, lessThanDay) => {
    switch (index) {
      case 0:
        return lessThanDay ? "hours" : "days";
      case 2:
        return lessThanDay ? "minutes" : "hours";
      default:
        return lessThanDay ? "seconds" : "minutes";
    }
  };

  renderItem(item, index, lessThanDay) {
    return index === 1 || index === 3 ? (
      <div key={`countdown-item-${index}`} className="countdown-timer__number">:</div>
    ) : (
      <div key={`countdown-item-${index}`} className="countdown-timer__item">
        <div className="countdown-timer__number">
          {("0" + item.number).slice(-2)}
        </div>
        <div className="countdown-timer__sign">
          {this.getSign(index, lessThanDay)}
        </div>
      </div>
    );
  }

  render() {
    const { countdownArray: countdownArrayRaw, lessThanDay } = this.state;
    const { isMenuExpanded } = this.props;

    /* To insert separators  */
    const countdownArray = [
      ...countdownArrayRaw.slice(0, 1),
      {},
      ...countdownArrayRaw.slice(1, 2),
      {},
      ...countdownArrayRaw.slice(2, 3)
    ];

    return (
      <div className={cn('countdown-timer', {
        'countdown-timer__hidden': !isMenuExpanded,
      })}>
        <div className="countdown-timer__title">Deadline</div>
        <div className="countdown-timer__row">
          {countdownArray.map((item, index) =>
            this.renderItem(item, index, lessThanDay)
          )}
        </div>
      </div>
    );
  }
}

export default Countdown;



// WEBPACK FOOTER //
// ./src/components/countdown/index.js